import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { useRouter } from 'vue-router'

import NeueButton from '@/components/neue/NeueButton'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import { useToast } from '@/composables/useToast'
import { getScrollParent } from '@/helpers/getScrollParent'
import { planLimitError } from '@/helpers/planLimits'
import api from '@/store/api'


export default {
  __name: 'StoreActions',
  props: {
  id: { type: [String, Number], default: null },
  name: { type: String, default: '' },
  isCatering: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props
const router = useRouter()
const el = ref(null)
const { showToast } = useToast()

const duplicate = () => {
  api
    .call('POST', `stores/${props.id}/duplicate`)
    .then(response => {
      getScrollParent(el.value).scrollTo({ top: 0 })
      router.push('/store/stores/' + response.data.data.id)
    })
    .catch(error => showToast(planLimitError(error) || 'Could not duplicate the store', { type: 'error' }))
}

const deleteStore = () => {
  if (!confirm(`Delete ${props.name}?`)) return
  api.call('DELETE', `stores/${props.id}`).then(() => {
    window.location.href = '/store/stores'
  })
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "el",
    ref: el,
    class: "max-w-[1040px]"
  }, [
    _createVNode(SettingsSection, {
      title: "Duplicate store",
      description: "Make a copy of this store, including all of its settings and product availability.",
      flush: ""
    }, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "min-w-0" }, [
          _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Duplicate this store"),
          _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "The copy opens as soon as it is ready.")
        ], -1)),
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          onClick: duplicate
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Duplicate", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!__props.isCatering)
      ? (_openBlock(), _createBlock(SettingsSection, {
          key: 0,
          title: "Delete store",
          description: "Removes this store and its settings. This cannot be undone.",
          flush: ""
        }, {
          default: _withCtx(() => [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "min-w-0" }, [
              _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Delete this store"),
              _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Removes this store and its settings. This cannot be undone. ")
            ], -1)),
            _createVNode(_unref(NeueButton), {
              type: "red",
              onClick: deleteStore
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Delete", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 512))
}
}

}